/** Ressources i18n — Italian (structure alignée sur `fr` / `de`). */
export const it = {
  translation: {
    common: {
      loading: 'Caricamento...',
      error: 'Si è verificato un errore',
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      edit: 'Modifica',
      add: 'Aggiungi',
      confirm: 'Conferma',
      back: 'Indietro',
      search: 'Cerca...',
      noResults: 'Nessun risultato',
      currency: 'CHF',
    },
    nav: {
      dashboard: 'Dashboard',
      orders: 'Ordini',
      products: 'Catalogo',
      stats: 'Statistiche',
      settings: 'Impostazioni',
      support: 'Assistenza',
      logout: 'Esci',
      login: 'Accedi',
      openMenu: 'Apri menu',
      closeMenu: 'Chiudi menu',
      mainNav: 'Navigazione principale',
    },
    session: {
      timeoutTitle: 'Disconnessione automatica',
      timeoutLabel: 'Timeout di inattività',
      timeoutHint: 'Dopo un periodo di inattività, verrai disconnesso automaticamente.',
      timeoutSaved: 'Timeout salvato.',
      timeout15: '15 minuti',
      timeout30: '30 minuti',
      timeout60: '1 ora',
      timeout120: '2 ore',
      timeout240: '4 ore',
      timeoutNever: 'Nessuno (non consigliato)',
      inactivityLogout: 'Sessione scaduta per inattività. Accedi di nuovo.',
    },
    auth: {
      login: 'Accedi',
      register: 'Registrati',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Password dimenticata?',
      noAccount: 'Non hai ancora un account?',
      hasAccount: 'Hai già un account?',
      demoAccountsTitle: 'Account demo:',
      demoAccountsHint: 'Clicca su una riga per precompilare email e password.',
      demoRoleAdmin: 'Amministratore',
      demoRoleMerchant: 'Commerciante',
      demoRoleDriver: 'Autista',
      demoRoleCustomer: 'Cliente',
    },
    dashboard: {
      welcome: 'Ciao, {{name}}!',
      todayOrders: 'Ordini oggi',
      todayRevenue: 'Incassi oggi',
      avgBasket: 'Carrello medio',
      avgRating: 'Valutazione media',
      newOrders: 'Nuovi ordini',
      inProgress: 'In corso',
      shopStatus: 'Stato del negozio',
      open: 'Aperto',
      closed: 'Chiuso',
      closeNow: 'Chiudi ora',
      topProducts: 'Prodotti più venduti oggi',
      storefrontPendingTitle: 'Vetrina in attesa di convalida',
      storefrontPending: 'La vetrina non è ancora online. I clienti non la vedono finché BienLivrer non l’ha convalidata.',
      plans: {
        link: 'Vedi le offerte',
        title: 'Le vostre offerte',
        intro: 'Avvio è gratuito. Pro e Premium abbassano la commissione e alzano il tetto del catalogo. Un’offerta a pagamento inizia il 1º del mese successivo, alle 00:00 (ora svizzera), e si rinnova ogni mese.',
        free: 'Gratuito',
        perMonth: '{{price}} CHF / mese',
        commission: 'Commissione {{rate}} %',
        products: '{{max}} prodotti in catalogo',
        current: 'Offerta attuale',
        choose: 'Scegliere {{name}}',
        backToStarter: 'Tornare ad Avvio',
        keep: 'Mantenere {{name}}',
        scheduled: 'Ritorno previsto',
        cancelScheduled: 'Ritorno ad Avvio il {{date}} alle 00:00 (ora svizzera). Fino a quella data l’offerta a pagamento resta attiva.',
        portal: 'Fatture e metodo di pagamento',
        checkoutUnavailable: 'L’abbonamento online non è ancora aperto. Scrivete a BienLivrer per cambiare offerta.',
        demoReadonly: 'L’account dimostrativo non può abbonarsi.',
        success: 'Carta registrata. L’abbonamento ricorrente sarà attivo il 1º del mese successivo alle 00:00 (ora svizzera).',
        cancelledCheckout: 'Abbonamento interrotto. Nessun addebito è stato fatto.',
        catalogOver: 'Il catalogo ha {{count}} prodotti, sopra il tetto di questa offerta ({{max}}). I prodotti già online restano; non potrete aggiungerne finché il surplus non è archiviato.',
        trialDefer: 'Il primo addebito avviene dopo la fine della prova.',
        trialSoon: 'La prova finisce tra meno di 48 ore: l’addebito mensile inizia con l’abbonamento.',
        error: 'Impossibile cambiare offerta in questo momento.',
        confirmTitle: 'Attivare un abbonamento ricorrente',
        confirmBody: 'State per attivare l’abbonamento {{name}} a {{price}} CHF al mese. Sarà attivo dal {{date}} alle 00:00 (ora svizzera). Poi si rinnova ogni mese, finché non tornate ad Avvio.',
        confirmYes: 'Attivare l’abbonamento',
        confirmNo: 'Annullare',
        confirmCancelTitle: 'Annullare l’abbonamento ricorrente',
        confirmCancelBody: 'State annullando l’abbonamento ricorrente {{name}}. Resta attivo fino al {{date}} alle 00:00 (ora svizzera). Da quella data tornate ad Avvio e l’addebito mensile si ferma.',
        confirmCancelPending: 'State annullando l’abbonamento ricorrente {{name}}. Non sarà attivato. L’annullamento vale dal {{date}} alle 00:00 (ora svizzera).',
        confirmCancelYes: 'Annullare l’abbonamento',
        confirmCancelNo: 'Indietro',
        pendingStart: '{{name}} sarà attivo il {{date}} alle 00:00 (ora svizzera). L’addebito si ripete ogni mese.',
        planned: 'Già previsto',
        names: {
          starter: 'Avvio',
          pro: 'Pro',
          premium: 'Premium',
        },
      },
    },
    orders: {
      title: 'Ordini',
      number: 'N. ordine',
      customer: 'Cliente',
      status: 'Stato',
      total: 'Totale',
      type: 'Tipo',
      date: 'Data',
      accept: 'Accetta',
      refuse: 'Rifiuta',
      markReady: 'Segna come pronto',
      prepare: 'Prepara',
      confirmPickup: 'Segna come ritirato',
      delivery: 'Consegna',
      click_collect: 'Ritiro',
      statuses: {
        pending: 'In attesa',
        accepted: 'Accettato',
        preparing: 'In preparazione',
        ready: 'Pronto',
        pickup: 'Corriere in arrivo',
        delivering: 'In consegna',
        delivered: 'Consegnato',
        completed: 'Ritirato',
        cancelled: 'Annullato',
        refunded: 'Rimborsato',
        pending_payment: 'Pagamento in attesa',
      },
    },
    products: {
      title: 'Il mio catalogo',
      add: 'Nuovo prodotto',
      name: 'Nome del prodotto',
      nameFr: 'Nome (francese)',
      nameDe: 'Nome (tedesco)',
      nameEn: 'Nome (inglese)',
      price: 'Prezzo CHF',
      stock: 'Scorte',
      unlimited: 'Illimitato',
      status: 'Stato',
      category: 'Categoria',
      active: 'Attivo',
      draft: 'Bozza',
      out_of_stock: 'Esaurito',
      allergens: 'Allergeni',
      vatRate: 'Aliquota IVA',
    },
    onboarding: {
      title: 'Crea il tuo negozio',
      step1: 'Informazioni di base',
      step2: 'Orari di apertura',
      step3: 'Coordinate bancarie',
      step4: 'Primo prodotto',
      next: 'Avanti',
      previous: 'Indietro',
      finish: 'Fine',
    },
    client: {
      home: 'Home',
      myOrders: 'I miei ordini',
      myProfile: 'Il mio profilo',
      cart: 'Carrello',
      addToCart: 'Aggiungi al carrello',
      addedToCartToast: 'Aggiunto al carrello',
      viewCart: 'Vedi carrello',
      addedToCartLive: '{{name}} aggiunto al carrello.',
      removeFromCart: 'Rimuovi dal carrello',
      emptyCart: 'Il tuo carrello è vuoto',
      orderNow: 'Ordina',
      deliveryAddress: 'Indirizzo di consegna',
      deliveryOrPickup: 'Consegna o ritiro?',
      notes: 'Note speciali (facoltativo)',
      coupon: 'Codice promozionale',
      applyCoupon: 'Applica',
      subtotal: 'Subtotale',
      deliveryFee: 'Costo di consegna',
      serviceFee: 'Commissione di servizio',
      packagingDeposit: 'Cauzione imballaggio',
      discount: 'Sconto',
      total: 'Totale',
      placeOrder: 'Effettua ordine',
      orderPlaced: 'Ordine effettuato!',
      trackOrder: 'Traccia il mio ordine',
      pickupCode: 'Codice di ritiro',
      estimatedTime: 'Tempo stimato',
      deliveryIn: 'Consegna in ~{{min}} min',
      pickupIn: 'Pronto in ~{{min}} min',
      activeOrders: 'Attivi',
      orderHistory: 'Cronologia',
      noActiveOrders: 'Nessun ordine attivo',
      noHistory: 'Nessun ordine precedente',
      checkout: {
        errorGeneric: 'Impossibile completare l\'ordine. Riprova.',
        errorNetwork: 'Nessuna connessione o server non raggiungibile.',
        errorServer: 'Errore del server. Riprova tra poco.',
        errorValidation: 'Dati non validi. Controlla il modulo.',
        errorUnauthorized: 'Accedi per effettuare un ordine.',
        submitting: 'Ordine in corso…',
        payCard: 'Pagamento online',
        payQrBill: 'QR-fattura',
        payCash: 'Contanti al ritiro',
        payCashHint:
          'Pagherai l\'importo totale (prodotti e commissione di servizio) in contanti alla cassa al ritiro.',
        payCashDeliveryOnly: 'Solo ritiro in negozio',
        payCashLocked:
          'Disponibile dalla {{fromOrder}}a ordine pagato online ({{current}}/{{required}} completati).',
        payCashUnavailableDeposit:
          'I contanti non sono disponibili: una cauzione imballaggio deve essere incassata online per potervela rimborsare.',
        payCashCta: 'Ordina e paga al ritiro — CHF {{total}}',
        cartDialogTitle: 'Carrello',
        cartOpened: 'Carrello aperto. {{count}} articolo/i. Totale {{total}} CHF.',
        cartClosed: 'Carrello chiuso.',
        loginToOrderTitle: 'Accesso richiesto',
        loginToOrderHint:
          'Accedi, crea un account o usa il modulo ospite qui sotto. Il carrello e le scelte (ritiro / consegna, pagamento) saranno conservati.',
        loginToOrderCta: 'Accedi per ordinare',
        loginToOrderRegister: 'Registrati',
        guestCheckoutToggle: 'Ordina come ospite',
        guestCheckoutHint:
          'Non viene creato un account. Utilizziamo questi dati solo per elaborare il tuo ordine e contattarti (conferma, consegna).',
        guestFirstNameLabel: 'Nome',
        guestLastNameLabel: 'Cognome',
        guestEmailLabel: 'Email',
        guestPhoneOptionalLabel: 'Telefono (facoltativo, +41…)',
        guestPhoneInvalid: 'Telefono non valido: usa +41 seguito da 9 cifre.',
        guestSubmitCta: 'Ordina come ospite',
        guestSubmitting: 'Invio in corso…',
        guestDividerOr: 'oppure',
        continueToPayment: 'Continua al pagamento',
        preparePaymentCta: 'Continua al pagamento — CHF {{total}}',
        orderWithPaymentObligation: 'Ordina con obbligo di pagamento — CHF {{total}}',
        acceptLegalRequired: 'Accetta le condizioni di vendita e le condizioni d\'uso per continuare.',
        paymentNotConfirmedYet:
          'Il tuo ordine sarà confermato solo dopo il pagamento riuscito (carta o TWINT).',
        backToSummary: 'Torna al carrello',
        stripePayTitle: 'Pagamento sicuro',
        stripePaySubtitle: 'Carta — il tuo ordine rimane in attesa fino alla conferma del pagamento.',
        stripePayCta: 'Paga CHF {{total}} — obbligo di pagamento',
        stripePayProcessing: 'Elaborazione…',
        awaitingPaymentTitle: 'Ordine ricevuto',
        awaitingPaymentBody:
          'Controlla la tua email per i passaggi successivi (carta o TWINT). Traccia l\'ordine in «I miei ordini».',
        awaitingPaymentBodyGuest:
          'Controlla la tua email per i passaggi successivi (carta o TWINT). Conserva il numero d\'ordine qui sotto.',
        stripePollTimeout: 'Il pagamento potrebbe essere ancora in conferma. Apri «I miei ordini» tra poco.',
        stripeOrderCancelled: 'L\'ordine è stato annullato (pagamento non riuscito).',
        wrongRoleHint:
          'Hai effettuato l\'accesso come commerciante o autista. Esci e usa un account cliente per ordinare qui.',
        sectionAccount: 'Account',
        sectionFulfillment: 'Ritiro o consegna',
        sectionYourOrder: 'Il tuo ordine',
        sectionSummary: 'Riepilogo',
        sectionPayment: 'Metodo di pagamento',
        signedInAs: 'Accesso effettuato come',
        tabHasAccount: 'Ho già un account',
        tabGuest: 'Ordina come ospite',
        deliveryAddressShort: 'Indirizzo di consegna',
        totalTvaHint: 'IVA inclusa ove applicabile',
        paymentChooseHint: 'Scegli come desideri pagare.',
        paymentOnlineHint:
          'Pagamento online sicuro con carta o TWINT (tramite Stripe). Nessun contante o QR-fattura.',
        serviceFeeHint: 'Include l\'elaborazione sicura del pagamento.',
      },
      ordersConnection: {
        offline: 'Offline — aggiornamento al riconnessione.',
        online: 'Online di nuovo.',
        syncing: 'Aggiornamento ordini…',
      },
      profile: {
        title: 'Il mio profilo',
        firstNameLabel: 'Nome',
        lastNameLabel: 'Cognome',
        emailLabel: 'Email',
        phoneLabel: 'Telefono',
        firstNameRequired: 'Nome obbligatorio',
        lastNameRequired: 'Cognome obbligatorio',
        emailInvalid: 'Email non valida',
        saveBtn: 'Salva',
        saved: 'Profilo salvato.',
        saveFailed: 'Salvataggio non riuscito. Riprova.',
        gdprTitle: 'Dati personali (GDPR)',
        gdprExport: 'Esporta i miei dati',
        gdprDelete: 'Elimina il mio account',
        gdprDeleteConfirm: 'Il conto verrà anonimizzato. Questa azione è irreversibile. Continuare?',
        gdprPasswordLabel: 'Password per confermare l’eliminazione',
        gdprPasswordRequired: 'Inserite la password per eliminare il conto.',
        gdprRequestSent: 'La tua richiesta è stata inviata.',
        changePasswordTitle: 'Cambia password',
        currentPassword: 'Password attuale',
        newPassword: 'Nuova password (min. 8 caratteri)',
        confirmPassword: 'Conferma nuova password',
        passwordMismatch: 'Le password non corrispondono',
        passwordChanged: 'Password modificata con successo.',
      },
      shop: {
        deliveryBadge: 'Consegna',
        clickCollectBadge: 'Click & Collect',
        pickup: 'Ritiro in negozio',
        deliveryWithFee: 'Consegna (+CHF {{fee}})',
        deliveryFromFee: 'Consegna (CHF {{fee}})',
        deliveryOutOfZone: 'Fuori zona di consegna',
        deliveryOffered: 'Offerta',
        deliveryOfferedLabel: 'Consegna offerta',
        categoryAll: 'Tutti',
        products: 'Prodotti',
        noProducts: 'Nessun prodotto disponibile',
        notFound: 'Negozio non trovato',
        orderPlacedTitle: 'Ordine effettuato!',
        orderPlacedBody: 'Il pagamento è confermato. Il tuo ordine è in elaborazione.',
        orderNumberLabel: 'N. ordine',
        pickupCodeLabel: 'Codice di ritiro',
        newOrder: 'Nuovo ordine',
        viewCartShort: 'Vedi carrello',
        cartArticleLabel: 'articoli',
        closeCartOverlay: 'Chiudi carrello',
        closeDialog: 'Chiudi',
        deliveryAddressLabel: 'Indirizzo di consegna *',
        deliveryAddressPlaceholder: 'Via principale 5, 2500 Città',
        orderNoteLabel: 'Nota (facoltativo)',
        orderNotePlaceholder: 'Allergie, senza glutine…',
        paymentMethod: 'Metodo di pagamento',
        onlineOrderPrice: 'Prezzo ordine online',
        onlineOrderPriceHint: 'I prezzi visualizzati valgono per l’ordine online.',
        packagingDeposit: 'Cauzione imballaggio +CHF {{amount}}',
        packagingDepositHint:
          'Cauzione per imballaggio speciale (catena del freddo, carne…). BienLivrer la trattiene e la rimborsa quando restituite l’imballaggio in negozio.',
      },
      homePage: {
        searchPlaceholder: 'Cerca un negozio...',
        closed: 'Chiuso',
        open: 'Aperto',
        demo: 'Demo',
        delivery: 'Consegna',
        pickup: 'Ritiro',
        minOrder: 'Min. CHF {{amount}}',
        driverArea: 'Area autista',
        driverProfile: 'Profilo autista',
        merchantDashboard: 'Dashboard commerciante',
        merchantSettings: 'Impostazioni negozio',
        admin: 'Amministrazione',
        myOrders: 'I miei ordini',
        myProfile: 'Il mio profilo',
        logout: 'Esci',
        login: 'Accedi',
        announcementCta: 'Contatto / dettagli',
        brandSlogan: 'Piccolo negozio, grande consegna.',
        heroTitle: 'Negozi locali, consegnati a casa',
        heroVision: 'Consegna locale in tutta la Svizzera',
        heroSubtitle: 'Ordina dai commercianti locali — consegna serale o ritiro in negozio',
        register: 'Registrati',
        loginCta: 'Accedi',
        hello: 'Ciao, {{name}}!',
        taglineDriver: 'Sfoglia la vetrina o gestisci le tue consegne',
        taglineMerchant: 'Vetrina o area commerciante',
        taglineAdmin: 'Vetrina o amministrazione',
        taglineCustomer: 'Cosa vorresti ordinare oggi?',
        deliveriesLink: 'Consegne',
        dashboardLink: 'Il mio negozio',
        ordersLink: 'I miei ordini',
        featured: 'In evidenza',
        pinned: 'Da non perdere',
        pinnedBadge: 'Scelta',
        newPartners: 'Nuovi partner',
        locationBanner: 'Negozi locali disponibili vicino a te',
        noResults: 'Nessun risultato',
        noShops: 'Nessun negozio disponibile',
        resetSearch: 'Reimposta ricerca',
        shopCountOne: '{{count}} negozio',
        shopCountMany: '{{count}} negozi',
      },
    },
    driver: {
      title: 'Le mie consegne',
      space: 'Area autista',
      available: 'Disponibile',
      unavailable: 'Non disponibile',
      activeDelivery: 'Consegna attiva',
      availableDeliveries: 'Missioni disponibili',
      earnings: 'Guadagni della settimana',
      accept: 'Accetta missione',
      refuse: 'Rifiuta',
      pickup: 'Ritira',
      deliver: 'Consegna',
      delivered: 'Consegna confermata',
      distance: 'Distanza',
      estimatedFee: 'Compenso stimato',
      noDeliveries: 'Nessuna missione disponibile',
      status: {
        searching: 'Ricerca autista',
        awaiting_manual: 'In attesa di assegnazione manuale',
        pending_acceptance: 'In attesa di conferma',
        assigned: 'Assegnato',
        heading_to_shop: 'In viaggio al negozio',
        at_shop: 'Al negozio',
        picked_up: 'Ordine ritirato',
        delivering: 'In consegna',
        delivered: 'Consegnato',
      },
    },
    admin: {
      title: 'Amministrazione',
      console: 'Console admin BienLivrer',
      myProfile: 'Il mio profilo',
      overview: 'Panoramica',
      shops: 'Negozi',
      users: 'Utenti',
      orders: 'Ordini',
      coupons: 'Coupon',
      reviews: 'Recensioni',
      activeShops: 'Negozi attivi',
      totalUsers: 'Utenti',
      totalOrders: 'Ordini totali',
      revenue: 'Incasso totale (CHF)',
      verify: 'Verifica',
      verified: 'Verificato',
      active: 'Attivo',
      inactive: 'Inattivo',
      suspended: 'Sospeso',
      owner: 'Titolare',
      createdAt: 'Creato',
      refresh: 'Aggiorna',
      sessionTimeoutTitle: 'Disconnessione automatica',
      sessionTimeoutHint: 'Dopo un periodo di inattività nella console admin, verrai disconnesso automaticamente.',
      sessionTimeoutSaved: 'Timeout salvato.',
      sessionTimeout15: '15 minuti',
      sessionTimeout30: '30 minuti',
      sessionTimeout60: '1 ora',
      sessionTimeout120: '2 ore',
      sessionTimeout240: '4 ore',
      sessionTimeoutNever: 'Nessuno (non consigliato)',
      sessionInactivityLogout: 'Sessione scaduta per inattività. Accedi di nuovo.',
    },
    gdpr: {
      cookieBanner: 'Utilizziamo i cookie per migliorare la tua esperienza.',
      closeBanner: 'Chiudi avviso cookie',
      accept: 'Accetta',
      decline: 'Rifiuta',
      learnMore: 'Scopri di più',
      privacyPolicy: 'Informativa sulla privacy',
      termsOfService: 'Condizioni d\'uso',
    },
    errors: {
      notFound: 'Pagina non trovata',
      unauthorized: 'Non autorizzato',
      serverError: 'Errore del server',
      networkError: 'Errore di rete — controlla la connessione',
      sessionExpired: 'Sessione scaduta — accedi di nuovo',
      shopClosed: 'Questo negozio è attualmente chiuso',
      outOfStock: 'Esaurito',
      minOrder: 'Ordine minimo non raggiunto (CHF {{amount}})',
    },
    merchantDemo: {
      bannerTitle: 'Ambiente demo',
      bannerBody: 'Negozio esempio « {{category}} ». Accetta, prepara, stampa e segui fino alla consegna — nulla viene salvato.',
      changeCategory: 'Cambia tipo di negozio',
      pickerTitle: 'Scegli il tipo di negozio',
      pickerSubtitle: 'L’area commerciante si adatta alla tua scelta (catalogo, ordini, statistiche…).',
      readOnlyHint: 'Percorso interattivo — per aprire il tuo negozio reale, registrati come partner.',
      persistBlocked: 'Ambiente demo — nessuna modifica salvata.',
    },
    driverDemo: {
      bannerTitle: 'Ambiente demo autista',
      bannerBody: 'Missioni, mappa e guadagni di esempio. Accetta e aggiorna gli stati — nulla viene salvato.',
      persistBlocked: 'Ambiente demo — nessuna modifica salvata.',
    },
    devTestAccounts: {
      title: 'Account di test',
      subtitle: 'Solo per sviluppo locale. Esegui il seed alla root del progetto: ',
      seedCmd: 'npm run db:seed',
      unavailable: 'Questa pagina non è disponibile in questo ambiente.',
      backHome: 'Home',
      backLogin: 'Accedi',
      columnRole: 'Ruolo',
      columnEmail: 'Email',
      columnPassword: 'Password',
      columnRedirect: 'Dopo l\'accesso',
      copyEmail: 'Copia email',
      copyPassword: 'Copia password',
      copied: 'Copiato',
      openLogin: 'Apri accesso con campi precompilati',
      roles: {
        admin: 'Amministratore',
        merchant: 'Commerciante',
        merchantDemo: 'Commerciante demo (vetrina)',
        merchantE2e: 'Commerciante test E2E',
        driverDemo: 'Autista demo (interattivo)',
        driver: 'Autista test E2E',
        customer: 'Cliente (catalogo)',
      },
      redirects: {
        admin: '/admin',
        merchant: '/dashboard',
        merchantDemo: '/demo/commerce',
        merchantE2e: '/dashboard',
        driver: '/driver',
        customer: '/client',
      },
      shopDemoTitle: 'Negozio demo',
      shopDemoSlug: '/shop/boulangerie-muller-biel',
      loginHint: 'Dalla pagina di accesso puoi anche usare i collegamenti rapidi sotto il modulo.',
      loginFullPageLink: 'Apri pagina dedicata agli account di test',
      securityNote: 'Non abilitare gli account di test in produzione; non committare segreti reali.',
    },
  },
};
